import { Selector } from '@ngxs/store';
import { FeatureflagsStateModel } from '@store/models/featureflags.model';
import { FeatureflagsState } from '@store/states/featureflags.state';
import { FeatureFlags } from '@models/featureflags.model';

export class FeatureflagsSelectors {
  @Selector([FeatureflagsState])
  static featureFlags(state: FeatureflagsStateModel): FeatureFlags {
    return state?.featureFlags ?? {};
  }

  @Selector([FeatureflagsState])
  static loading(state: FeatureflagsStateModel): boolean {
    return state?.loading ?? false;
  }

  @Selector([FeatureflagsState])
  static loaded(state: FeatureflagsStateModel): boolean {
    return state?.loaded ?? false;
  }

  @Selector([FeatureflagsState])
  static savingKey(state: FeatureflagsStateModel): string | null {
    return state?.savingKey ?? null;
  }
}
